"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var analytics_1 = require("@sendspark/analytics");
var VideoPlayer_1 = __importDefault(require("./VideoPlayer"));
var VideoPlayerIds_1 = __importDefault(require("./VideoPlayerIds"));
var VideoPlayerController_1 = __importDefault(require("./VideoPlayerController"));
var Placeholder_1 = __importDefault(require("./components/Placeholder"));
var RenderIf_1 = __importDefault(require("./components/RenderIf"));
var VideoPreviewPlayer_1 = __importDefault(require("./VideoPreviewPlayer"));
var VideoPreviewController_1 = __importDefault(require("./VideoPreviewController"));
var VideoPlayerControllerProvider = react_1.forwardRef(function (_a, ref) {
    var _b, _c;
    var campaign = _a.campaign, embed = _a.embed, analyticsTracker = _a.analyticsTracker, _d = _a.isEditPage, isEditPage = _d === void 0 ? false : _d, apiV2Url = _a.apiV2Url, muxDataEnv = _a.muxDataEnv, _e = _a.muxDataDebug, muxDataDebug = _e === void 0 ? false : _e, style = _a.style, className = _a.className, events = _a.events, _f = _a.preview, preview = _f === void 0 ? false : _f, videoSources = _a.videoSources, _g = _a.autoPlay, autoPlay = _g === void 0 ? false : _g, _h = _a.thumbsUp, thumbsUp = _h === void 0 ? false : _h, _j = _a.gapCombinedVideoPlayer, gapCombinedVideoPlayer = _j === void 0 ? true : _j, _k = _a.disableKeyboardControls, disableKeyboardControls = _k === void 0 ? false : _k;
    var _l = react_1.useState(null), controller = _l[0], setController = _l[1];
    var _m = react_1.useState(false), isReady = _m[0], setIsReady = _m[1];
    // Creates the Video Player Controller
    react_1.useEffect(function () {
        var video = document.getElementById(VideoPlayerIds_1.default.VideoPlayer);
        if (video) {
            var videoContainer = document.getElementById(VideoPlayerIds_1.default.VideoContainer);
            var buttonPlay = document.getElementById(VideoPlayerIds_1.default.ButtonPlay);
            var buttonFullscreen = document.getElementById(VideoPlayerIds_1.default.ButtonFullscreen);
            var buttonVolume = document.getElementById(VideoPlayerIds_1.default.ButtonVolume);
            var progressBar = document.getElementById(VideoPlayerIds_1.default.ProgressBar);
            var inputVolumeRange = document.getElementById(VideoPlayerIds_1.default.InputVolumeRange);
            var buttonNextVideo = document.getElementById(VideoPlayerIds_1.default.ButtonNextVideo);
            var progressBarCustomIntro = document.getElementById(VideoPlayerIds_1.default.ButtonNextVideo);
            // here
            if (campaign && !preview && isReady) {
                var videoPlayerAnalytics = new analytics_1.VideoPlayerAnalytics(campaign, video, analyticsTracker, isEditPage);
                setController(new VideoPlayerController_1.default({
                    video: video,
                    videoContainer: videoContainer,
                    buttonPlay: buttonPlay,
                    buttonFullscreen: buttonFullscreen,
                    buttonVolume: buttonVolume,
                    buttonNextVideo: buttonNextVideo,
                    progressBar: progressBar,
                    progressBarCustomIntro: progressBarCustomIntro,
                    inputVolumeRange: inputVolumeRange,
                    campaign: campaign,
                    apiBaseUrl: apiV2Url,
                    videoPlayerAnalytics: videoPlayerAnalytics,
                    isEditPage: isEditPage,
                    events: events,
                    embed: embed,
                    autoPlay: autoPlay,
                    thumbsUp: thumbsUp,
                    gapCombinedVideoPlayer: gapCombinedVideoPlayer
                }));
            }
            else if (preview && videoSources) {
                setController(new VideoPreviewController_1.default({
                    video: video,
                    videoContainer: videoContainer,
                    buttonPlay: buttonPlay,
                    buttonFullscreen: buttonFullscreen,
                    buttonVolume: buttonVolume,
                    buttonNextVideo: buttonNextVideo,
                    progressBar: progressBar,
                    progressBarCustomIntro: progressBarCustomIntro,
                    inputVolumeRange: inputVolumeRange,
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaign, analyticsTracker, isReady]);
    var campaignHasVideo = ((_c = (_b = campaign === null || campaign === void 0 ? void 0 : campaign.meta) === null || _b === void 0 ? void 0 : _b.video) === null || _c === void 0 ? void 0 : _c.muxStatus) === 'ready';
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: preview && !!videoSources }, { children: jsx_runtime_1.jsx(VideoPreviewPlayer_1.default, { videoSources: videoSources, controller: controller }, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !!campaign }, { children: campaignHasVideo ?
                    jsx_runtime_1.jsx(VideoPlayer_1.default, { autoPlay: autoPlay, thumbsUp: thumbsUp, gapCombinedVideoPlayer: gapCombinedVideoPlayer, campaign: campaign, controller: controller, embed: embed, muxDataEnv: muxDataEnv, muxDataDebug: muxDataDebug, isEditPage: isEditPage, style: style, className: className, ref: ref, setIsReady: setIsReady, disableKeyboardControls: disableKeyboardControls }, void 0) :
                    jsx_runtime_1.jsx(Placeholder_1.default, { embed: embed }, void 0) }), void 0)] }, void 0));
});
exports.default = VideoPlayerControllerProvider;
